import { FieldTextarea, Form, FormikForm, FormRowField } from "@skilitics/designer-ui-components";

export type CustomCssFormValues = {
  customCss: string;
};

interface Props {
  initialValues: CustomCssFormValues;
  onSubmit: (values: CustomCssFormValues) => void;
}

export const CustomCssForm = ({ initialValues, onSubmit }: Props) => {
  return (
    <FormikForm<CustomCssFormValues>
      initialValues={initialValues}
      onSubmit={onSubmit}
      submitOnBlur
      formatStrings={formatStrings}
      dataTest="custom-css-form"
    >
      <Form style={{ marginTop: "-5px" }} blurOnEnter={false}>
        <FormRowField<CustomCssFormValues> name="customCss">
          <FieldTextarea minRows={5} maxRows={20} spellCheck={false} />
        </FormRowField>
      </Form>
    </FormikForm>
  );
};

const formatStrings = {
  customCssLabel: {
    en: "CSS",
  },
};
